import { StyledIconButtonWrapper } from "../Buttons/StyledIconButtonWrapper";
import { DefaultLabel } from "./DefaultLabel";

export const IconButtonLabel = StyledIconButtonWrapper(DefaultLabel);
